/** Finance's advance list (F4.9-p) as CSV → rows to check before import. */
import { parseRupeesToPaise } from '@/lib/money'
import { parseCsv } from '../lib/csv'

export interface ParsedAdvance {
  line: number
  /** Roster number (farmer_code) or a farmer id. */
  who: string
  amountPaise: number | null
  occurredAt: string
  externalRef: string
  problem: string | null
}

/** Columns: roster no (or farmer id), amount ₹, date YYYY-MM-DD, reference. A header row is optional. */
export function parseAdvanceCsv(text: string): ParsedAdvance[] {
  const rows = parseCsv(text)
  const first = rows[0]?.map((c) => c.trim().toLowerCase()) ?? []
  const hasHeader = first.some((c) => /roster|farmer|amount|ref|date/.test(c))
  const col = (names: string[], fallback: number) => {
    const i = first.findIndex((c) => names.some((n) => c.includes(n)))
    return hasHeader && i >= 0 ? i : fallback
  }
  const cWho = col(['roster', 'farmer', 'code'], 0)
  const cAmt = col(['amount', 'inr', '₹'], 1)
  const cDate = col(['date', 'occurred', 'given'], 2)
  const cRef = col(['ref', 'voucher', 'receipt'], 3)
  return rows.slice(hasHeader ? 1 : 0).map((r, i) => {
    const who = (r[cWho] ?? '').trim()
    const amountPaise = parseRupeesToPaise(r[cAmt] ?? '')
    const occurredAt = (r[cDate] ?? '').trim()
    const externalRef = (r[cRef] ?? '').trim()
    let problem: string | null = null
    if (!who) problem = 'No roster number'
    else if (amountPaise === null || amountPaise <= 0) problem = 'Amount must be ₹ > 0 with at most 2 decimals'
    else if (!/^\d{4}-\d{2}-\d{2}/.test(occurredAt)) problem = 'Date must be YYYY-MM-DD'
    else if (!externalRef) problem = 'No reference'
    return { line: i + (hasHeader ? 2 : 1), who, amountPaise, occurredAt, externalRef, problem }
  })
}

